// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.people-chips {
	width: 416px;
	max-width: calc(100vw - 16px);
}
`, "",{"version":3,"sources":["webpack://./react/containers/FeedbackDrawers/drawers/FeedbackDrawer/FeedbackDrawer.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,6BAA6B;AAC9B","sourcesContent":[".people-chips {\n\twidth: 416px;\n\tmax-width: calc(100vw - 16px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
